import { z } from 'zod';

export const dealerSchema = z.object({
  fullName: z.string().min(1, 'Full Name is required'),
  email: z.string().min(1, 'Email is required').email('Invalid email'),
  dealerShipName: z.string().optional(),
  preferredContactPhoneNumber: z
    .string()
    .min(1, 'Preferred Contact Phone Number is required')
    .refine((v) => !v || /^\+?[0-9\-\s]{7,15}$/.test(v), { message: 'Invalid phone number' }),
  website: z.string().optional(),
  averageNumberOfVehiclesInInventory: z.string().min(1, 'Average Number of Vehicles is required'),
  address: z.string().min(1, 'Address is required'),
  countryCode: z.string().min(1, 'Country is required'),
  stateCode: z.string().min(1, 'State is required'),
  zipCode: z.string().min(1, 'ZIP code is required'),
  city: z.string().min(1, 'City is required'),
  aboutBusiness: z.string().min(1, 'Please tell us about your business'),
  latitude: z.string().optional(),
  longitude: z.string().optional(),
});

export type DealerFormValues = z.infer<typeof dealerSchema>;
